import { useMemo } from 'react';

function usePlaceholders(isFetched: boolean, count: number = 10): null[] {
  return useMemo(() => {
    if (isFetched) {
      return [];
    }

    const placeholders = [];

    for (let i = 0; i < count; i++) {
      placeholders.push(null);
    }

    return placeholders;
  }, [count, isFetched]);
}

export { usePlaceholders };
